import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AHSS = () =>{
  
  return (
    <div className="Eresources">
    
      <section className="inner-banner banner-align">
        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/innerbanner/ahss.jpg"} alt="AHSS"/>
      </section>
      <section  className="research-box-area">
           <Container>
           <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/find-resources">
                  Find Resources
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>AHSS</BreadcrumbItem>
              </Breadcrumb>
              <div className='information-content'>
                <h2>AHSS</h2>
                {/* <p>THe HU LICS has access to the following online research databases:</p> */}
              </div>
              <Row className="ParentBorderBox">
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/jstor.png"} alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 3039 E-Journals</p>
            <p><b>Subject Coverage:</b></p>
            <p>JSTOR archive cover many disciplines such as Arts & Sciences, Business, Ecology & Botany, General Science, Language & Literature, Music</p>
        </div>
        <a className="link-btn" target="_blank" href="https://www.jstor.org/"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />JSTOR</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/jstor-sustainability.png"} alt="" />
        </div>
        <div className="subjects">
            {/* <p><b>Coverage:</b> All volumes from 2003 till 2022</p> */}
            <p><b>Subject Coverage:</b></p>
            <p>JSTOR Sustainability Collection Covers Subjects including environmental studies, environmental science, business, economics, law, aquatic & atmospheric sciences, ecology, urban studies and the built environment.</p>
        </div>
        <a className="link-btn" target="_blank" href="https://www.jstor.org/sustainability/"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />JSTOR: Sustainability Collection</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/ProQuest-Dissertations.png"} alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> Over 2.1 million full-text dissertations and theses</p>
            <p><b>Subject Coverage:</b></p>
            <p>Business and Economics, Medical Sciences, Science, Technology, Agriculture, Social Science, Arts, Humanities.</p>
        </div>
        <a className="link-btn" target="_blank" href="https://www.proquest.com/"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />ProQuest Dissertations & Theses Global</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/informs-logo.png"} alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 12 E-Journals</p>
            <p><b>Subject Coverage:</b></p>
            <p>Operations Research, Management Science, Analytics, Information System, Decision Analysis, Research Theory, Marketing Research and Science, Computing and Information Technologies.</p>
        </div>
        <a className="link-btn" target="_blank" href="https://pubsonline.informs.org/"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />Informs</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/springer-logo.png"} alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 2541 E-Journals, 102 E-Books, 57 Protocols</p>
            <p><b>Subject Coverage:</b></p>
            <p>Astronomy, Behavioral & Social Sciences, Computer Science, Engineering, Environmental Science, Geoscience, Humanities, Law, Life science, Mathematics, Medicine, Physics.</p>
        </div>
        <a className="link-btn" target="_blank" href="https://link.springer.com/search?facet-content-type=%22Journal%22&showAll=false"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />SpringerLink</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/taylor-logo.png"} alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 2921 E-Journals</p>
            <p><b>Subject Coverage:</b></p>
            <p>Arts & Humanities, Engineering, Computing & Technology, Media, Cultural & Communication Studies, Politics, International Relations &7 Area Studies, Sociology & Related Disciplines.</p>
        </div>
        <a className="link-btn" target="_blank" href="https://www.tandfonline.com/"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />Taylor & Francis Online</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/wiley-logo.png"} alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resource:</b> 1576 E-Journals</p>
            <p><b>Subject Coverage:</b></p>
            <p>Architecture & Planning, Art & Applied Arts, Computer Science & Information Technology, Earth, Space & Environmental Science, Humanities, Physical Sciences & Engineering, Social & Behavioral Sciences.</p>
        </div>
        <a className="link-btn" target="_blank" href="https://onlinelibrary.wiley.com/action/showPublications"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />Wiley Online Library </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/imf-e-library.png"} alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resource:</b> 11,000 Text Publications </p>
            <p><b>Subject Coverage:</b></p>
            <p>The IMF eLibrary includes the IMF Statistics, IMF Periodicals, IMF books and Analytical Papers. </p>
        </div>
        <a className="link-btn" target="_blank" href="https://www.elibrary.imf.org/"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />IMF eLIBRARY</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src={process.env.PUBLIC_URL + "/assets/img/researchtool/eresources/bloomsburry-logo.png"} alt="" />
        </div>
        <div className="subjects">
            {/* <p><b>Available Resource:</b> All volumes from 2003 till 2022</p> */}
            <p><b>Subject Coverage:</b></p>
            <p> It contains 121 eBooks, World History of Design 2 volumes, Encyclopedia Asian Design, Designer Biographies, thousands of images from Exhibition Archive and different museums across the globe e.g. Museums across the globe e.g. Museum collection from museum of art and design New York, Philadelphia Museum of Art, the National Archive, Design museum Denmark and Museum of Craft and Design </p>
        </div>
        <a className="link-btn" target="_blank" href="https://www.bloomsburydesignlibrary.com/login?recentUrl=/home"><img src={process.env.PUBLIC_URL + "/assets/img/link-icon.svg"} alt="" />Bloomsbury Design Library</a>
    </div>
    </Col>
</Row>
           </Container>
      </section>
     
    </div>
  );
}
export default AHSS;